import { Link } from 'react-router-dom';
import CarrouselRealisations from './CarrouselRealisations';

function DetailService({ titre, categorie, image, description, etapes, realisations }) {
    return (
        <div>
            {/* Bannière */}
            <div className="relative h-[280px] w-full overflow-hidden bg-gray-100 dark:bg-bleu-gris">
                {image && (
                    <img
                        src={image}
                        alt={titre}
                        className="w-full h-full object-cover opacity-30 dark:opacity-20"
                    />
                )}
                <div className="absolute inset-0 flex flex-col justify-center items-center px-6 text-center space-y-2">
                    <span className="text-bleu-je text-sm font-semibold uppercase tracking-widest dark:text-bleu-sombre">
                        {categorie}
                    </span>
                    <h1 className="font-comme font-bold text-[32px] md:text-[46px] leading-tight text-gris-sombre dark:text-blanc-sombre max-w-3xl">
                        {titre}
                    </h1>
                </div>
            </div>

            {/* Corps */}
            <div className="bg-white dark:bg-fond-sombre">
                <div className="max-w-5xl mx-auto px-6 py-14">

                    {/* Description */}
                    <p className="text-gris-sombre dark:text-gray-300 text-[20px] leading-relaxed text-center mx-auto mb-16">
                        {description}
                    </p>

                    {/* Déroulement de l'étude */}
                    {etapes && etapes.length > 0 && (
                        <div className="mb-16">
                            <h2 className="text-gris-sombre dark:text-blanc-sombre text-[28px] font-semibold text-center mb-10">
                                Déroulement de <span className="text-bleu-je">l'étude</span>
                            </h2>
                            <div className="relative">
                                <div className="absolute left-[28px] top-0 bottom-0 w-[2px] bg-bleu-je opacity-20 hidden md:block" />
                                <div className="flex flex-col gap-8">
                                    {etapes.map((etape) => (
                                        <div key={etape.numero} className="flex gap-6 items-start">
                                            <div className="flex-shrink-0 w-14 h-14 rounded-full bg-bleu-je flex items-center justify-center text-white font-bold text-xl shadow-md z-10">
                                                {etape.numero}
                                            </div>
                                            <div className="flex-1 bg-gray-50 dark:bg-bleu-gris rounded-[8px] p-5 shadow-sm border border-gray-100 dark:border-gray-700">
                                                <h3 className="text-bleu-je font-bold text-[16px] mb-2 dark:text-bleu-sombre">
                                                    {etape.titre}
                                                </h3>
                                                <p className="text-base text-[14px] leading-relaxed">
                                                    {etape.texte}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Réalisations */}
                    {realisations && realisations.length > 0 && (
                        <>
                            <h2 className="text-gris-sombre dark:text-blanc-sombre text-[28px] font-semibold text-center mb-8">
                                Nos <span className="text-bleu-je">Réalisations</span>
                            </h2>
                            <CarrouselRealisations realisations={realisations} />
                        </>
                    )}

                    {/* CTA retour */}
                    <div className="flex justify-center">
                        <Link
                            to="/services"
                            className="px-6 py-3 border-2 border-bleu-je text-bleu-je font-semibold rounded-[4px] hover:bg-bleu-je hover:text-white transition-colors duration-200"
                        >
                            ← Voir tous nos services
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default DetailService;
